import React, { useCallback } from 'react';
import { Box, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';
import { PageTitle, PageContainer } from '../../../components/Common';
import { useStoreSelector } from '../../../hooks/Magasins/useStoreSelector';
import { StoreSelector, StoreSelectorSkeleton } from './components';
import StoreLayout from '../UpdateStore/components/StoreLayout';
import StoreLayoutSkeleton from '../UpdateStore/components/StoreLayoutSkeleton';

const ShowStore = () => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    
    const {
        listStores,
        storeData,
        selectedStoreId,
        entityId,
        loadingList,
        loadingStore,
        errorList,
        errorStore,
        notFound,
        handleStoreChange,
        handleEntityIdChange,
        handleShowClick,
        refetchStore,
    } = useStoreSelector();
    
    const handleEditClick = useCallback(() => {
        navigate('/store/update-store', { state: { storeId: selectedStoreId } });
    }, [navigate, selectedStoreId]);

    return (
        <PageContainer>
            <PageTitle>{t('pages.store.showStore')}</PageTitle>
            <Box sx={{ mb: 3 }}>
                {loadingList ? (
                    <StoreSelectorSkeleton />
                ) : errorList ? (
                    <Alert severity="error">{errorList}</Alert>
                ) : (
                    <StoreSelector
                        stores={listStores || []}
                        selectedStoreId={selectedStoreId}
                        entityId={entityId}
                        onStoreChange={handleStoreChange}
                        onEntityIdChange={handleEntityIdChange}
                        onShowClick={handleShowClick}
                        onEditClick={handleEditClick}
                        isEditable={false}
                        hideShowButton
                    />
                )}
            </Box>
            {loadingStore && <StoreLayoutSkeleton />}
            {errorStore && !notFound && (
                <Alert severity="error" sx={{ mb: 3 }}>{errorStore}</Alert>
            )}
            {storeData && !loadingStore && <StoreLayout store={storeData} isEditable={false} onRefetch={refetchStore} listStoresOptions={listStores || []} />}
        </PageContainer>
    );
};

export default ShowStore;
